(function () {
  // === Ajustes rápidos ===
  const COD_ENABLED  = true;
  const COD_LABEL    = 'Comprar por WhatsApp · ¡Pago contra entrega!';
  const COD_WHATSAPP = '573229707924';
  const COD_TEXT     = 'Holaa!👋🏻, Quiero Pagar Contra Entrega,lo siguiente...';

  // ====== UPSELL (Complementarios Shopify) ======
  const UPSELL_ENABLED = true;
  const UPSELL_LIMIT = 6;

  // Asegura que exista el root
  let root = document.getElementById('zk-cart-root');
  if (!root) {
    root = document.createElement('div');
    root.id = 'zk-cart-root';
    document.body.appendChild(root);
  }

  function money(cents, locale = 'es-CO', currency = 'COP') {
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch {
      return '$' + Math.round(cents / 100).toLocaleString();
    }
  }

  function ensureShell() {
    if (root.dataset.ready) return;

    root.innerHTML = `
      <div class="zk-overlay" data-zk-close></div>
      <div class="zk-panel">
        <header class="zk-header">
          <h2 class="zk-title">🛒 CARRITO DE COMPRAS</h2>
          <button class="zk-close" aria-label="Cerrar" data-zk-close>&times;</button>
        </header>

        <!-- 🚚 Barra de progreso de envío gratis -->
        <div class="zk-cart-free-shipping">
          <div class="zk-progress-wrap">
            <div class="zk-progress-fill"></div>
            <div class="zk-truck-icon">🚚</div>
          </div>
          <p class="zk-free-shipping-text">
            Faltan <span class="zk-amount">—</span> para obtener Envío Gratuito
          </p>
        </div>

        <div class="zk-body" id="zk-cart-body"></div>

        <footer class="zk-footer">
          <div class="zk-subtotal">
            <span>Subtotal:</span>
            <strong id="zk-subtotal-amount">—</strong>
          </div>
          <p class="zk-note">Impuestos incluidos y envío calculado al finalizar la compra.</p>
          <form action="/checkout" method="post">
            <button class="zk-btn zk-btn-primary" name="checkout" type="submit">
              <span class="zk-btn-content" style="display:flex;flex-direction:column;align-items:center;line-height:1.1;">
                <span class="zk-btn-title">COMPRAR AHORA • ENVÍO INMEDIATO</span>
                <span class="zk-btn-subtext" style="font-size:10px;opacity:.9;margin-top:2px;">Pago seguro con tarjeta, datos protegidos.</span>
              </span>
            </button>
          </form>

          

          ${
            COD_ENABLED
              ? `<button type="button" class="zk-btn zk-btn-cod" id="zkCodBtn">${COD_LABEL}</button>`
              : ``
          }
<div class="zk-paymethods-single">
            <div class="zk-paymethods-title"></div>
            <img
              src="https://cdn.shopify.com/s/files/1/0767/6562/6598/files/pagosegurozaeskids.png?v=1768280441"
              alt="Métodos de pago seguros"
              loading="lazy"
              class="zk-paymethods-img"
            />
          </div>
        </footer>
      </div>`;

    root.dataset.ready = '1';

    // === CIERRE ROBUSTO ===
    const overlay = root.querySelector('.zk-overlay');
    ['click', 'touchstart'].forEach(evt => {
      overlay.addEventListener(
        evt,
        e => {
          if (root.classList.contains('zk-open')) {
            e.preventDefault?.();
            closeDrawer();
          }
        },
        { passive: false }
      );
    });

    const closeBtn = root.querySelector('.zk-close');
    ['click', 'touchstart'].forEach(evt => {
      closeBtn.addEventListener(
        evt,
        e => {
          e.preventDefault?.();
          closeDrawer();
        },
        { passive: false }
      );
    });

    ['mousedown', 'touchstart'].forEach(evt => {
      root.addEventListener(
        evt,
        e => {
          if (!e.target.closest('.zk-panel') && root.classList.contains('zk-open')) {
            e.preventDefault?.();
            closeDrawer();
          }
        },
        { passive: false }
      );
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && root.classList.contains('zk-open')) closeDrawer();
    });
  }

  function openDrawer() {
    ensureShell();
    const overlay = root.querySelector('.zk-overlay');
    if (overlay) {
      overlay.style.background = 'rgba(0,0,0,0.72)';
      overlay.style.opacity = '1';
      overlay.style.pointerEvents = 'auto';
    }
    root.classList.add('zk-open');
    document.documentElement.classList.add('zk-noscroll');
  }

  function closeDrawer() {
    const overlay = root.querySelector('.zk-overlay');
    if (overlay) {
      overlay.style.opacity = '0';
      overlay.style.pointerEvents = 'none';
    }
    root.classList.remove('zk-open');
    document.documentElement.classList.remove('zk-noscroll');
  }

  // ====== API carrito ======
  async function getCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('cart.js failed');
    return await r.json();
  }

  // Usamos el key único del ítem
  async function changeItemByKey(key, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!r.ok) throw new Error('change failed');
    return await r.json();
  }

  async function updateQtyByKey(key, qty) {
    const bodyEl = document.getElementById('zk-cart-body');
    try {
      const cart = await changeItemByKey(key, qty);
      renderCart(cart);
    } catch (e) {
      console.error(e);
      if (bodyEl) {
        bodyEl.innerHTML =
          '<div style="padding:16px;color:#b00">No se pudo actualizar la cantidad.</div>';
      }
    }
  }

  // ====== LINKS ======
  function itemLinkFrom(it) {
    if (it.url) return it.url;
    const handle = it.handle || it.product_handle || '';
    const variant = it.variant_id || it.id || '';
    if (handle) return `/products/${handle}${variant ? `?variant=${variant}` : ''}`;
    return '/cart';
  }

  // ==============================
  // ✅ VARIANT SWITCH
  // ==============================
  const _productCache = new Map();
  const IS_ANDROID = /Android/i.test(navigator.userAgent);

  function getHandleFromUrl(url) {
    if (!url) return '';
    const m = url.match(/\/products\/([^?]+)/);
    return (m && m[1]) ? m[1] : '';
  }

  async function fetchProductJs(handle) {
    if (!handle) return null;
    if (_productCache.has(handle)) return _productCache.get(handle);
    try {
      const r = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
      if (!r.ok) return null;
      const data = await r.json();
      _productCache.set(handle, data);
      return data;
    } catch (e) {
      return null;
    }
  }

  function variantLabel(v) {
    if (!v) return '—';
    const parts = [];
    if (v.option1) parts.push(v.option1);
    if (v.option2) parts.push(v.option2);
    if (v.option3) parts.push(v.option3);
    return parts.join(' / ') || '—';
  }

  async function addVariant(variantId, quantity) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) })
    });
    if (!r.ok) throw new Error('add failed');
    return r.json();
  }

  async function replaceVariantByKey(oldKey, newVariantId, quantity) {
    // 1) add nueva variante
    await addVariant(newVariantId, quantity);
    // 2) remove la anterior por key
    await changeItemByKey(oldKey, 0);
  }

  // ---------- ANDROID: botón + lista ----------
  async function enhanceVariantListForItem(li, it) {
    if (!li || li.__zkVariantReadyAndroid) return;
    li.__zkVariantReadyAndroid = true;

    const btn = li.querySelector('[data-zk-variant-btn]');
    const btnText = li.querySelector('[data-zk-variant-btn-text]');
    const menu = li.querySelector('[data-zk-variant-menu]');
    const wrap = li.querySelector('[data-zk-variant-wrap]');
    if (!btn || !btnText || !menu || !wrap) return;

    const handle = getHandleFromUrl(it.url);
    if (!handle) { wrap.style.display = 'none'; return; }

    const product = await fetchProductJs(handle);
    if (!product || !product.variants || product.variants.length <= 1) {
      wrap.style.display = 'none';
      return;
    }

    const currentId = String(it.variant_id);
    const current = product.variants.find(v => String(v.id) === currentId);
    btnText.textContent = current ? variantLabel(current) : 'Selecciona…';

    menu.innerHTML = '';
    for (const v of product.variants) {
      const id = String(v.id);
      const disabled = (v.available === false);

      const row = document.createElement('button');
      row.type = 'button';
      row.style.cssText = `
        width:100%;
        padding:12px 10px;
        border:0;
        background:${id === currentId ? 'rgba(0,0,0,.05)' : '#fff'};
        display:flex;
        justify-content:space-between;
        align-items:center;
        font-size:14px;
        cursor:${disabled ? 'not-allowed' : 'pointer'};
        opacity:${disabled ? '.5' : '1'};
      `;
      row.disabled = disabled;
      row.dataset.variantId = id;
      row.innerHTML = `<span>${variantLabel(v)}${disabled ? ' (Agotado)' : ''}</span>${id === currentId ? '<span>✓</span>' : ''}`;

      row.addEventListener('click', async () => {
        const newId = row.dataset.variantId;
        if (!newId || String(newId) === String(it.variant_id)) {
          menu.hidden = true;
          return;
        }

        btn.disabled = true;
        try {
          await replaceVariantByKey(it.key, newId, it.quantity || 1);
          const cart = await getCart();
          renderCart(cart);
        } catch (err) {
          console.error(err);
          alert('No se pudo cambiar la variante. Intenta de nuevo.');
          btn.disabled = false;
        }
      });

      menu.appendChild(row);
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      menu.hidden = !menu.hidden;
    });

    // cerrar tocando fuera del item
    if (!document.__zkVariantOutsideClose) {
      document.__zkVariantOutsideClose = true;
      document.addEventListener('click', (e) => {
        document.querySelectorAll('[data-zk-variant-menu]').forEach(m => {
          const parentItem = m.closest('li.zk-item');
          if (parentItem && !parentItem.contains(e.target)) m.hidden = true;
        });
      });
    }
  }

  // ---------- iPhone/PC: <select> ----------
  async function enhanceVariantSelectForItem(li, it) {
    if (!li || li.__zkVariantReadySelect) return;
    li.__zkVariantReadySelect = true;

    const select = li.querySelector('[data-zk-variant-select]');
    const wrap = li.querySelector('[data-zk-variant-wrap]');
    if (!select || !wrap) return;

    const handle = getHandleFromUrl(it.url);
    if (!handle) { wrap.style.display = 'none'; return; }

    const product = await fetchProductJs(handle);
    if (!product || !product.variants || product.variants.length <= 1) {
      wrap.style.display = 'none';
      return;
    }

    const currentId = String(it.variant_id);

    // construir options
    select.innerHTML = '';
    for (const v of product.variants) {
      const opt = document.createElement('option');
      opt.value = String(v.id);
      opt.textContent = `${variantLabel(v)}${v.available === false ? ' (Agotado)' : ''}`;
      opt.disabled = (v.available === false);
      if (String(v.id) === currentId) opt.selected = true;
      select.appendChild(opt);
    }

    select.disabled = false;

    // change handler (evita duplicar)
    if (!select.__zkBound) {
      select.__zkBound = true;
      select.addEventListener('change', async () => {
        const newId = String(select.value || '');
        if (!newId || newId === String(it.variant_id)) return;

        select.disabled = true;
        try {
          await replaceVariantByKey(it.key, newId, it.quantity || 1);
          const cart = await getCart();
          renderCart(cart);
        } catch (err) {
          console.error(err);
          alert('No se pudo cambiar la variante. Intenta de nuevo.');
          select.disabled = false;
        }
      });
    }
  }

  async function enhanceAllVariantSelects(cart) {
    const bodyEl = document.getElementById('zk-cart-body');
    if (!bodyEl || !cart || !cart.items) return;

    const lis = bodyEl.querySelectorAll('li.zk-item[data-key]');
    for (const li of lis) {
      const key = li.getAttribute('data-key');
      const it = cart.items.find(x => String(x.key) === String(key));
      if (!it) continue;

      // eslint-disable-next-line no-await-in-loop
      if (IS_ANDROID) {
        await enhanceVariantListForItem(li, it);
      } else {
        await enhanceVariantSelectForItem(li, it);
      }
    }
  }

  // ==============================
  // ✅ UPSELL: Complementary products
  // ==============================
  async function fetchComplementary(productId, limit = 6) {
    const url = `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&intent=complementary`;
    const r = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!r.ok) return [];
    const data = await r.json();
    return (data && data.products) ? data.products : [];
  }

  function isProductInCart(cart, productId) {
    if (!cart || !cart.items) return false;
    return cart.items.some(it => String(it.product_id) === String(productId));
  }

  function renderUpsellBlock(products) {
    if (!products || !products.length) return '';

    const cards = products.map(p => {
      const img = (p.featured_image || '').replace(/(\?|$)/, '?width=220&$1');
      const price = (typeof p.price === 'number') ? money(p.price) : '';
      const firstVariantId = (p.variants && p.variants[0] && p.variants[0].id) ? p.variants[0].id : null;

      return `
        <div style="
          min-width: 240px;
          display: grid;
          grid-template-columns: 78px 1fr;
          gap: 10px;
          align-items: center;
          border: 1px solid rgba(0,0,0,.08);
          border-radius: 14px;
          background: #fff;
          padding: 10px;
        ">
          <a href="${p.url}" style="display:block; text-decoration:none;">
            <img src="${img}" alt="${escapeHtml(p.title)}" loading="lazy"
              style="width:78px;height:78px;object-fit:contain;border-radius:12px;background:#f7f7f7;display:block;" />
          </a>

          <div style="min-width:0;">
            <a href="${p.url}" class="zk-upsell-title" aria-label="Ir a ${escapeHtml(p.title)}">
              ${escapeHtml(p.title)}
            </a>

            <div class="zk-upsell-price-row">
              <a href="${p.url}" class="zk-upsell-price" aria-label="Ver precio de ${escapeHtml(p.title)}">${price}</a>
              <a href="${p.url}" class="zk-upsell-eye" aria-label="Ver ${escapeHtml(p.title)}" title="Ver producto">👁</a>
            </div>
          </div>

          <div style="grid-column:1/-1;">
            ${
              firstVariantId
                ? `<button type="button" data-zk-upsell-add="${firstVariantId}"
                    style="width:100%;border:0;border-radius:12px;padding:10px 12px;font-weight:900;cursor:pointer;">
                    + Agregar
                  </button>`
                : ''
            }
          </div>
        </div>
      `;
    }).join('');

    return `
      <div style="
        margin: 10px 12px 2px;
        padding: 12px;
        border: 1px solid rgba(0,0,0,.08);
        border-radius: 16px;
        background: #fff;
      ">
        <div style="font-weight:900;font-size:16px;margin:0 0 10px;">Te podría interesar</div>

        <div class="zk-upsell-slider" data-zk-upsell-slider>
          <button type="button" class="zk-upsell-nav zk-upsell-prev" data-zk-upsell-prev aria-label="Anterior">‹</button>

          <div class="zk-upsell-viewport" data-zk-upsell-viewport>
            <div class="zk-upsell-track" data-zk-upsell-track>
              ${cards}
            </div>
          </div>

          <button type="button" class="zk-upsell-nav zk-upsell-next" data-zk-upsell-next aria-label="Siguiente">›</button>

          <div class="zk-upsell-dots" data-zk-upsell-dots aria-label="Paginación"></div>
        </div>
      </div>
    `;
  }


  // ✅ Slider UPSELL: botones izquierda/derecha + bolitas
  function initUpsellSlider(scopeEl) {
    const slider = scopeEl && scopeEl.querySelector('[data-zk-upsell-slider]');
    if (!slider) return;

    const viewport = slider.querySelector('[data-zk-upsell-viewport]');
    const dotsBox = slider.querySelector('[data-zk-upsell-dots]');
    const btnPrev = slider.querySelector('[data-zk-upsell-prev]');
    const btnNext = slider.querySelector('[data-zk-upsell-next]');
    if (!viewport || !dotsBox) return;

    if (slider.__zkInited) return;
    slider.__zkInited = true;

    function pageCount() {
      const w = viewport.clientWidth || 1;
      const total = viewport.scrollWidth || 0;
      return Math.max(1, Math.ceil(total / w));
    }

    function currentPage() {
      const w = viewport.clientWidth || 1;
      return Math.max(0, Math.min(pageCount() - 1, Math.round(viewport.scrollLeft / w)));
    }

    function scrollToPage(idx) {
      const w = viewport.clientWidth || 1;
      const max = pageCount() - 1;
      const next = Math.max(0, Math.min(max, idx));
      viewport.scrollTo({ left: next * w, behavior: 'smooth' });
    }

    function rebuildDots() {
      const pages = pageCount();
      dotsBox.innerHTML = '';
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'zk-upsell-dot';
        b.setAttribute('aria-label', `Ir a página ${i + 1}`);
        b.addEventListener('click', () => scrollToPage(i));
        dotsBox.appendChild(b);
      }
      updateUI();
    }

    function updateUI() {
      const pages = pageCount();
      const idx = currentPage();
      const dots = dotsBox.querySelectorAll('.zk-upsell-dot');
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));

      const hasOverflow = viewport.scrollWidth > viewport.clientWidth + 2;
      slider.classList.toggle('zk-no-overflow', !hasOverflow);

      if (btnPrev) btnPrev.disabled = (!hasOverflow || idx <= 0);
      if (btnNext) btnNext.disabled = (!hasOverflow || idx >= pages - 1);
    }

    if (btnPrev) btnPrev.addEventListener('click', () => scrollToPage(currentPage() - 1));
    if (btnNext) btnNext.addEventListener('click', () => scrollToPage(currentPage() + 1));

    viewport.addEventListener('scroll', () => window.requestAnimationFrame(updateUI), { passive: true });

    let rTO = null;
    window.addEventListener('resize', () => {
      clearTimeout(rTO);
      rTO = setTimeout(rebuildDots, 120);
    });

    rebuildDots();
  }

  async function mountUpsell(cart) {
    if (!UPSELL_ENABLED) return;
    const box = document.getElementById('zk-upsell');
    if (!box) return;

    // si está vacío, no mostrar
    if (!cart || !cart.items || !cart.items.length) {
      box.innerHTML = '';
      return;
    }

    // mostrar "cargando" suave
    box.innerHTML = `<div style="padding: 10px 12px; opacity:.75; font-size:13px;">Cargando sugerencias…</div>`;

    // Semillas: intentamos con varios productos del carrito hasta completar el límite
    const collected = [];
    const seen = new Set();

    for (const it of cart.items) {
      // eslint-disable-next-line no-await-in-loop
      const recs = await fetchComplementary(it.product_id, UPSELL_LIMIT);
      for (const p of recs) {
        if (!p || !p.id) continue;
        if (seen.has(String(p.id))) continue;
        if (isProductInCart(cart, p.id)) continue;

        seen.add(String(p.id));
        collected.push(p);

        if (collected.length >= UPSELL_LIMIT) break;
      }
      if (collected.length >= UPSELL_LIMIT) break;
    }

    if (!collected.length) {
      box.innerHTML = '';
      return;
    }

    box.innerHTML = renderUpsellBlock(collected);

    // ✅ activar slider (botones + bolitas)
    initUpsellSlider(box);

    // binds botones agregar
    box.querySelectorAll('[data-zk-upsell-add]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = btn.getAttribute('data-zk-upsell-add');
        if (!variantId) return;

        btn.disabled = true;
        btn.textContent = 'Agregando…';

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });

          const newCart = await getCart();
          renderCart(newCart);
        } catch (e) {
          console.error(e);
          btn.disabled = false;
          btn.textContent = '+ Agregar';
          alert('No se pudo agregar. Intenta de nuevo.');
        }
      });
    });
  }

  // ====== Render Carrito ======
  function renderCart(cart) {
    const bodyEl = document.getElementById('zk-cart-body');
    const subtotalEl = document.getElementById('zk-subtotal-amount');
    if (!bodyEl) return;

    if (!cart.items.length) {
      bodyEl.innerHTML = '<div style="padding:16px">Tu carrito está vacío.</div>';
    } else {
      const itemsHTML = cart.items
        .map(it => {
          const title = it.product_title || it.title || '';
          const href = itemLinkFrom(it);
          const imgSrc = it.image
            ? it.image.replace(/(\?|$)/, '?width=200&height=200&fit=contain$1')
            : '';
          const variant =
            it.variant_title && it.variant_title !== 'Default Title'
              ? `<div class="zk-variant">${it.variant_title}</div>`
              : '';

          // selector de variantes: iOS/PC usa <select>, Android usa botón+lista
          const variantPicker = IS_ANDROID
            ? `
              <div class="zk-variant-picker" data-zk-variant-wrap style="margin-top:6px; display:block;">
                <div style="display:block; font-size:12px; opacity:.75; margin-bottom:4px;">Color/Diseño</div>

                <button type="button"
                  data-zk-variant-btn
                  style="width:100%; padding:10px 10px; border:1px solid #e8e8e8; border-radius:12px; font-size:14px; background:#fff; display:flex; justify-content:space-between; align-items:center;">
                  <span data-zk-variant-btn-text>Cargando…</span>
                  <span style="opacity:.6;">▾</span>
                </button>

                <div data-zk-variant-menu hidden
                  style="margin-top:8px; border:1px solid #e8e8e8; border-radius:12px; overflow:hidden; background:#fff;">
                </div>
              </div>
            `
            : `
              <div class="zk-variant-picker" data-zk-variant-wrap style="margin-top:6px; display:block;">
                <label style="display:block; font-size:12px; opacity:.75; margin-bottom:4px;">Color/Diseño</label>
                <select data-zk-variant-select disabled
                  style="width:100%; padding:10px 10px; border:1px solid #e8e8e8; border-radius:12px; font-size:14px; background:#fff;">
                  <option>Cargando…</option>
                </select>
              </div>
            `;

          return `
            <li class="zk-item" data-key="${it.key}">
              <a class="zk-img-link" href="${href}" data-item-link aria-label="Ver ${escapeHtml(title)}">
                <img class="zk-img" src="${imgSrc}" alt="${escapeHtml(title)}" loading="lazy">
              </a>
              <div class="zk-meta">
                <a class="zk-title" href="${href}" data-item-link aria-label="Ir a ${escapeHtml(title)}">
                  ${title}
                </a>
                ${variant}
                ${variantPicker}
                <div class="zk-price-row">
  <span class="zk-price-text">
    ${money(it.final_line_price)}
  </span>
</div>

                <div class="zk-qty">
                  <button class="zk-qty-btn" data-zk-minus data-key="${it.key}">−</button>
                  <span class="zk-qty-num">${it.quantity}</span>
                  <button class="zk-qty-btn" data-zk-plus data-key="${it.key}">+</button>
                  <button class="zk-remove" title="Eliminar" data-zk-remove data-key="${it.key}">🗑️</button>
                </div>
              </div>
            </li>
          `;
        })
        .join('');

      // ✅ Inserta upsell al final del body
      bodyEl.innerHTML = `<ul class="zk-items">${itemsHTML}</ul><div class="zk-upsell" id="zk-upsell"></div>`;
    }

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    // 🔄 Actualiza barra de envío gratis
    try {
      updateFreeShippingBar(cart.total_price);
    } catch (e) {
      console.error('[FreeShippingBar]', e);
    }

    // === Listeners usando key único ===
    bodyEl.querySelectorAll('[data-zk-minus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const current = Number(btn.parentElement.querySelector('.zk-qty-num').textContent);
        updateQtyByKey(key, Math.max(0, current - 1));
      });
    });

    bodyEl.querySelectorAll('[data-zk-plus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const current = Number(btn.parentElement.querySelector('.zk-qty-num').textContent);
        updateQtyByKey(key, current + 1);
      });
    });

    bodyEl.querySelectorAll('[data-zk-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        updateQtyByKey(key, 0);
      });
    });

    // ✅ Habilitar variantes al final del render (async)
    enhanceAllVariantSelects(cart);

    // ✅ Montar upsell (async)
    mountUpsell(cart);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  async function refreshAndShow() {
    openDrawer();
    const bodyEl = document.getElementById('zk-cart-body');
    if (bodyEl) {
      bodyEl.innerHTML = '<div style="padding:16px">Cargando carrito…</div>';
    }
    try {
      const cart = await getCart();
      renderCart(cart);
      document
        .querySelectorAll('.cart-count-bubble .cart-count,[data-cart-count]')
        .forEach(el => (el.textContent = cart.item_count));
    } catch (e) {
      console.error(e);
      if (bodyEl) {
        bodyEl.innerHTML =
          '<div style="padding:16px;color:#b00">Error cargando el carrito.</div>';
      }
    }
  }

  // Exponer para hooks externos
  window.ZKCart = { refreshAndShow, open: openDrawer, close: closeDrawer };

  /* ===============================
   COD BTN -> CERRAR CARRITO Y ABRIR FORMULARIO GLOBAL
  ================================ */
  document.addEventListener('click', async function(e){
    const btn = e.target.closest('#zkCodBtn');
    if (!btn) return;

    e.preventDefault();

    try{
      const res = await fetch('/cart.js', { headers: { Accept:'application/json' }});
      if(!res.ok) throw new Error('No se pudo leer /cart.js');
      const cart = await res.json();

      if(!cart.items || !cart.items.length){
        alert('Tu carrito está vacío.');
        return;
      }

      let msg = `Hola 👋🏻
✅Quiero pedir *CONTRA ENTREGA* con los siguientes productos:

`;

      cart.items.forEach((it, i) => {
        const title = it.product_title || it.title || 'Producto';
        const variant =
          it.variant_title && it.variant_title !== 'Default Title'
            ? ` (${it.variant_title})`
            : '';
        const qty = it.quantity || 1;
        const line = Math.round((it.final_line_price || 0) / 100);

        msg += `📌 ${i+1}. ${title}${variant}
`;
        msg += `Cantidad: ${qty}
`;
        msg += `Precio: $${line.toLocaleString('es-CO')}

`;
      });

      const total = Math.round((cart.total_price || 0) / 100);
      msg += `💰 *Total del pedido:* $${total.toLocaleString('es-CO')}

`;
      msg += `Quiero confirmar disponibilidad del producto y valor total con Envio📦🙏`;

      if (window.ZKCart && typeof window.ZKCart.close === 'function') {
        window.ZKCart.close();
      } else {
        root.classList.remove('zk-open');
        document.documentElement.classList.remove('zk-noscroll');
      }

      // 1) Cierra el mini carrito (igual que ya lo haces)
if (window.ZKCart && typeof window.ZKCart.close === 'function') {
  window.ZKCart.close();
} else {
  root.classList.remove('zk-open');
  document.documentElement.classList.remove('zk-noscroll');
}

// 2) Dispara evento para que el modal COD se abra con el carrito
document.dispatchEvent(new CustomEvent('zk:cod:open', {
  detail: {
    source: 'cart',
    cart: {
      items: (cart.items || []).map(it => ({
  title: it.product_title || it.title || 'Producto',
  variant: (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '',
  qty: it.quantity || 1,
  line_price: it.final_line_price || 0,
  url: it.url ? (location.origin + it.url) : '',
  image: it.image || it.featured_image || ''   // ✅ NUEVO
})),

      total_price: cart.total_price || 0 // en centavos
    }
  }
}));

// 3) Si por alguna razón el modal no existe en esta página, fallback a WhatsApp directo
if (!window.ZKCOD || typeof window.ZKCOD.openFromCart !== 'function') {
  const phone = COD_WHATSAPP;
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
  window.location.href = url;
}


    }catch(err){
      console.error('[COD->WA]', err);
    }
  });

  /* ===============================
   BLOQUEAR MINI-CARRITO CUANDO COD ESTÁ ABIERTO
  ================================ */
  document.addEventListener('click', function(e){
    if (document.body.classList.contains('zk-cod-open')) {
      if (e.target.closest('#zkCodModal')) {
        e.stopPropagation();
        return;
      }
    }
  }, true);

  document.addEventListener('change', function(e){
    if (document.body.classList.contains('zk-cod-open')) {
      if (e.target.closest('#zkCodModal')) {
        e.stopPropagation();
        return;
      }
    }
  }, true);

  // Enganchar formularios clásicos también
  function hookForms() {
    document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
      if (form.__zkHooked) return;
      form.__zkHooked = true;

      form.addEventListener(
        'submit',
        async ev => {
          ev.preventDefault();
          const data = new FormData(form);
          try {
            const add = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: data
            });
            if (!add.ok) throw new Error('add failed');
            await refreshAndShow();
          } catch (e) {
            console.error(e);
            form.submit(); // fallback
          }
        },
        { passive: false }
      );
    });
  }

  document.addEventListener('DOMContentLoaded', hookForms);
  new MutationObserver(hookForms).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // === 🚚 Barra de envío gratis ===
  function updateFreeShippingBar(subtotalCents) {
    const GOAL = 299000;
    const subtotal = subtotalCents / 100;
    const percent = Math.max(0, Math.min(100, (subtotal / GOAL) * 100));

    const wrap = document.querySelector('.zk-cart-free-shipping');
    if (!wrap) return;

    let progressWrap = wrap.querySelector('.zk-progress-wrap');
    if (!progressWrap) {
      progressWrap = document.createElement('div');
      progressWrap.className = 'zk-progress-wrap';
      progressWrap.style.cssText = `
        position: relative;
        width: 100%;
        height: 8px;
        background: #eee;
        border-radius: 999px;
        overflow: hidden;
        margin: 6px 0 4px;
      `;
      wrap.insertBefore(progressWrap, wrap.querySelector('.zk-free-shipping-text'));
    }

    let fill = progressWrap.querySelector('.zk-progress-fill');
    if (!fill) {
      fill = document.createElement('div');
      fill.className = 'zk-progress-fill';
      fill.style.cssText = `
        height: 100%;
        width: 0%;
        border-radius: 999px;
        transition: width 0.4s ease, background 0.4s ease;
      `;
      progressWrap.appendChild(fill);
    }

    let truck = progressWrap.querySelector('.zk-truck-icon');
    if (!truck) {
      truck = document.createElement('div');
      truck.className = 'zk-truck-icon';
      truck.style.cssText = `
        position: absolute;
        top: -20px;
        left: 0%;
        width: 0px;
        height: 0px;
        pointer-events: none;
        line-height: 0;
        transition: left 0.4s ease, filter 0.4s ease;
        box-shadow: none !important;
        filter: none !important;
      `;
      progressWrap.appendChild(truck);
    }

    // Inyectar animación si no existe
    if (!document.getElementById('zk-diagonal-move-style')) {
      const style = document.createElement('style');
      style.id = 'zk-diagonal-move-style';
      style.textContent = `
        @keyframes zkDiagonalSmooth {
          from { background-position: 0 0; }
          to   { background-position: 100px 0; }
        }
      `;
      document.head.appendChild(style);
    }

    const successGradient = 'linear-gradient(90deg, #27ae60 0%, rgb(122, 242, 148) 100%)';

    fill.style.width = percent + '%';
    fill.style.display = 'block';
    fill.style.opacity = '1';
    fill.style.borderRadius = '999px';
    fill.style.transition = 'width 0.5s ease, background 0.5s ease';

    if (subtotal < GOAL) {
      fill.style.background = `
        repeating-linear-gradient(
          45deg,
          #FFEB3B 0 35px,
          #FFD000 35px 70px
        )
      `;
      fill.style.backgroundSize = '100px 100px';
      fill.style.animation = 'zkDiagonalSmooth 2s linear infinite';
      fill.style.filter = 'brightness(1.05)';
    } else {
      fill.style.background = successGradient;
      fill.style.animation = 'none';
      fill.style.filter = 'none';
    }

    // SVG camión
    truck.innerHTML = `
      <img src="https://cdn.shopify.com/s/files/1/0767/6562/6598/files/camion-zaes.svg?v=1762751908"
           alt="Camión Envío Gratis"
           style="width:80px;height:64px;display:block;object-fit:contain;filter:none;box-shadow:none;" />
    `;

    truck.style.left = `calc(${percent}% - 60px)`;

    const text = wrap.querySelector('.zk-free-shipping-text');
    if (!text) return;

    if (subtotal >= GOAL) {
      wrap.classList.add('zk-free-shipping-success');
      text.innerHTML = '🎉 <strong>¡Felicidades!</strong> Ya tienes <strong>envío gratis</strong> ';
      truck.style.filter = 'hue-rotate(80deg) saturate(80%) brightness(1)';
    } else {
      wrap.classList.remove('zk-free-shipping-success');
      const remaining = GOAL - subtotal;
      const diff = remaining.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        maximumFractionDigits: 0
      });
      text.innerHTML = `Faltan <strong>${diff}</strong> para obtener <strong>envío gratis</strong>`;
      truck.style.filter = 'none';
    }
  }

  // Debug opcional
  window.updateFreeShippingBar = updateFreeShippingBar;

})(); // fin IIFE

// Hook externo para formularios .zk-card-atc-form (fuera del IIFE)
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.zk-card-atc-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();

      const formData = new FormData(form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error('Error al agregar al carrito');

        if (window.ZKCart && typeof window.ZKCart.refreshAndShow === 'function') {
          window.ZKCart.refreshAndShow();
        } else if (typeof window.zkCartDrawer === 'function') {
          window.zkCartDrawer('open');
        } else if (document.querySelector('.cart-drawer')) {
          document.querySelector('.cart-drawer').classList.add('is-open');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (error) {
        console.error('Error al agregar al carrito:', error);
      }
    });
  });
});
